<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: "svg-icon",
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    }
  }
};
</script>

<style scoped>
.svg-icon {
  width: 18px;
  height: 18px;
  vertical-align: -0.28em;
  fill: currentColor;
  overflow: hidden;
}
.el-menu-item > .svg-icon {
  width: 18px !important;
  height: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue